const AUTH_ERROR_MAP: Array<{ pattern: RegExp; message: string }> = [
  { pattern: /çok fazla deneme yaptınız/i, message: 'Too many attempts. Please try again later.' },
  { pattern: /kullanıcı adı veya şifre boş olamaz/i, message: 'Username and password are required.' },
  { pattern: /bu hesap google ile kayıtlı/i, message: 'This account uses Google sign-in. Please continue with Google.' },
  { pattern: /kullanıcı adı veya şifre hatalı/i, message: 'Incorrect username or password.' },
  { pattern: /böyle bir kullanıcı yok/i, message: 'No account found with these credentials.' },
  { pattern: /bu işlem için yetkiniz yok/i, message: 'You are not authorized to perform this action.' },
  { pattern: /taklit edilecek kullanıcı bulunamadı/i, message: 'The impersonation target user could not be found.' },
  { pattern: /google doğrulaması başarısız/i, message: 'Google sign-in verification failed. Please try again.' },
  { pattern: /google hesabından email alınamadı/i, message: 'Could not read an email from your Google account.' },
  { pattern: /geçerli bir email giriniz/i, message: 'Please enter a valid email address.' },
  { pattern: /daha güçlü bir şifre giriniz/i, message: 'Please use a stronger password (8+ chars, upper/lowercase, number, symbol).' },
  { pattern: /k\.\s*adı çok 5 ile 24 karakter arası olabilir/i, message: 'Username must be between 5 and 24 characters.' },
  { pattern: /bu kullanıcı adı veya email alınmış/i, message: 'This username or email is already in use.' },
  { pattern: /geçersiz veya süresi dolmuş şifre sıfırlama bağlantısı/i, message: 'This password reset link is invalid or has expired.' },
]

function normalizeAuthErrorMessage(errorMessage: string): string {
  return errorMessage
    .replace(/^GraphQL error:\s*/i, '')
    .replace(/^ApolloError:\s*/i, '')
    .trim()
}

export function toEnglishAuthError(errorMessage?: string | null): string | null {
  if (!errorMessage) {
    return null
  }

  const normalized = normalizeAuthErrorMessage(errorMessage)
  const mapped = AUTH_ERROR_MAP.find(({ pattern }) => pattern.test(normalized))
  return mapped ? mapped.message : normalized
}
